import {BaseCachedService} from "./Core/BaseCachedService";
import {BaseService} from "./Core/BaseService";
import {BaseSearchableService} from "./Core/BaseSearchableService";

class FunderService extends BaseSearchableService {
    get Url() { return super.Url + "/funders"; }
    get ModelName() { return "Funder"; }
    get PrimaryKeyProperty() { return "funderId"; }
    get TitleProperty() { return "name"; }
    
    GetModel(funderId) {
        return this.SendRequest(BaseService.GET, funderId);
    }
    
    CreateModel(funder) {
        this.FlushCache();
        return this.SendRequest(BaseService.POST, funder);
    }
    
    UpdateModel(funder) {
        this.FlushCache();
        return this.SendRequest(BaseService.PUT, funder);
    }
    
    DeleteModel(funderId) {
        this.FlushCache();
        return this.SendRequest(BaseService.DELETE, funderId);
    }
}

export const service = new FunderService();

